
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import NotifyContent from 'components/NotifyContent'

export class NotificationView extends React.Component {
  static propTypes = {
  }

  render() {
    return (
      <div className='notifications-view'>
        <NotifyContent onFullPage showFilter={false} />
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
  }
}
const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(NotificationView)



// WEBPACK FOOTER //
// ./client/views/NotificationView/index.js